import React = require('react')

export const Use = ({ use }: { use: () => void }) => {
  use()
  return <></>
}
